import React from "react"
import { HtmlDocumentViewer } from "./html-document-viewer"
import { SHELL_COLUMN_FOOTER_CLASS } from "@/lib/shell-chrome"
import { testIds } from "@/lib/test-ids"
import { cn } from "@/lib/utils"

export type DocumentContentHtmlPanelProps = {
  content: string
  documentTitle?: string
}

export function DocumentContentHtmlPanel({
  content,
  documentTitle,
}: DocumentContentHtmlPanelProps) {
  return (
    <div className="relative flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-hidden">
        <HtmlDocumentViewer html={content} documentTitle={documentTitle} />
      </div>
      <div
        className={cn(
          SHELL_COLUMN_FOOTER_CLASS,
          "flex items-center justify-between gap-2 border-t border-border bg-muted/30 px-2 text-xs text-muted-foreground min-w-0 shrink-0",
        )}
        data-testid={testIds.documentContentHtmlStatusBar.root}
      >
        <span className="min-w-0 truncate">
          HTML <span aria-hidden>{"\u00b7"}</span> preview in app; edit file on disk or use update tools
        </span>
        <span className="shrink-0 tabular-nums" data-testid={testIds.documentContentHtmlStatusBar.stats}>
          {content.length.toLocaleString()} chars{" "}
          <span aria-hidden>{"\u00b7"}</span>{" "}
          {content.split("\n").length.toLocaleString()} lines
        </span>
      </div>
    </div>
  )
}
